import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { ConfigError } from './components/common/ConfigError';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const root = ReactDOM.createRoot(rootElement);

// Dynamically import App to catch Firebase config errors at import time
import('./App')
  .then(({ default: App }) => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://cra.link/PWA
    serviceWorkerRegistration.unregister();

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
  })
  .catch((error: Error) => {
    console.error('Application initialization failed:', error);

    const message = error.message.includes('REACT_APP_FIREBASE')
      ? 'Firebase configuration is missing. Please ensure all required REACT_APP_FIREBASE_* environment variables are set in your .env file.'
      : `Failed to initialize application: ${error.message}`;

    root.render(
      <React.StrictMode>
        <ConfigError message={message} />
      </React.StrictMode>
    );
  });
